import ShareButton from './share-button';

export default ShareButton;